import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { gallery } from '@/mocks/site';

export default function Gallery() {
  return (
    <section className="relative bg-background-50 py-20 md:py-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-foreground-950/10" />
      <div className="container-wide">
        <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
          <Reveal>
            <SectionHeading
              label="Sur le terrain"
              title={
                <>
                  Le métier,
                  <br />
                  en images
                </>
              }
            />
          </Reveal>
          <Reveal delay={120}>
            <div className="md:text-right">
              <p className="max-w-sm text-sm leading-relaxed text-foreground-600 md:ml-auto">
                Atelier, chantier, formation : nos réalisations parlent mieux que n'importe quelle
                plaquette. Voici une partie du travail de nos équipes.
              </p>
              <Link
                to="/realisations"
                className="group mt-4 inline-flex items-center gap-2 whitespace-nowrap text-xs font-semibold uppercase tracking-[0.12em] text-primary-600 transition-colors hover:text-primary-700"
              >
                Voir les études de cas
                <i className="ri-arrow-right-line text-sm transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </div>
          </Reveal>
        </div>

        <div className="mt-12 columns-2 gap-3 lg:columns-3">
          {gallery.map((item, index) => (
            <div key={item.image} className="mb-3 break-inside-avoid">
              <Reveal delay={(index % 3) * 80}>
                <figure className="group relative cursor-pointer overflow-hidden rounded-lg bg-background-300 ring-1 ring-inset ring-foreground-950/10">
                  <div
                    className={`w-full overflow-hidden ${
                      item.tall ? 'aspect-[3/4]' : 'aspect-[4/3]'
                    }`}
                  >
                    <img
                      src={item.image}
                      alt={item.caption}
                      title={`${item.caption} — SGSCTIC`}
                      className="h-full w-full object-cover object-top transition-transform duration-[900ms] ease-smooth group-hover:scale-[1.06]"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/10 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                  <figcaption className="absolute inset-x-0 bottom-0 translate-y-3 p-5 opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                    <span className="label-mono text-primary-300">Chantier</span>
                    <p className="mt-1 text-sm font-medium text-background-50">{item.caption}</p>
                  </figcaption>
                </figure>
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}